function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';

const SvgComponent = ({
  color,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 9 18",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.869 11.254v.45l.436-.111 1.434-.365a.45.45 0 01.493.674l-3.06 4.924a.45.45 0 01-.764 0l-3.063-4.924a.45.45 0 01.493-.674l1.437.365.437.11V6.427l-.434.107-1.453.36a.45.45 0 01-.49-.675l3.073-4.94a.45.45 0 01.765 0l3.07 4.94a.45.45 0 01-.491.674l-1.45-.358-.433-.108v4.827z",
  fill: color,
  stroke: "#828A90"
}));

SvgComponent.propTypes = {
  color: PropTypes.string
};
SvgComponent.defaultProps = {
  color: '#DAF0ED'
};
export default SvgComponent;